<template>
  <div class="wizard-steps mb-5">
    <div class="wizard-step" :class="stepClass(1)">
      <span class="wizard-step-index">1</span>
      <span class="wizard-step-text">Identificação</span>
    </div>
    <div class="wizard-step" :class="stepClass(2)">
      <span class="wizard-step-index">2</span>
      <span class="wizard-step-text">Planilhas e dashes</span>
    </div>
    <div class="wizard-step" :class="stepClass(3)">
      <span class="wizard-step-index">3</span>
      <span class="wizard-step-text">Conferir e enviar</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MassCustomerCategoriesWizardProgress',
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
  },
  methods: {
    stepClass(step) {
      return {
        active: this.currentStep === step,
        done: this.currentStep > step,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
